import React from 'react';
import ReactDOM from 'react-dom';
import Buffer from 'buffer';

import App from './App';
import { ContextProvider } from './Context';

import './styles.css';

const myBuffer = Buffer;
console.log(myBuffer);

ReactDOM.render(
  <ContextProvider>
    <App />
  </ContextProvider>,
  document.getElementById('root'),
);
